import { render } from "./ImageEditorGallery.vue?vue&type=template&id=f4e357d4"
import script from "./ImageEditorGallery.vue?vue&type=script&lang=js"
export * from "./ImageEditorGallery.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__